var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9V21H18V9H6ZM5.25 7.5C4.83579 7.5 4.5 7.83579 4.5 8.25V21.75C4.5 22.1642 4.83579 22.5 5.25 22.5H18.75C19.1642 22.5 19.5 22.1642 19.5 21.75V8.25C19.5 7.83579 19.1642 7.5 18.75 7.5H5.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C10.3431 3.75 9 5.09315 9 6.75V10.5C9 10.9142 8.66421 11.25 8.25 11.25C7.83579 11.25 7.5 10.9142 7.5 10.5V6.75C7.5 4.26472 9.51472 2.25 12 2.25C14.4852 2.25 16.5 4.26446 16.5 6.7498V10.5C16.5 10.9142 16.1642 11.25 15.75 11.25C15.3358 11.25 15 10.9142 15 10.5V6.7498C15 5.093 13.6569 3.75 12 3.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5C9 13.9142 8.66421 14.25 8.25 14.25C7.83579 14.25 7.5 13.9142 7.5 13.5C7.5 13.0858 7.83579 12.75 8.25 12.75C8.66421 12.75 9 13.0858 9 13.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag24);
export default __webpack_public_path__ + "static/media/ShoppingBag-24.6b814027.svg";
export { ForwardRef as ReactComponent };